<template>
    
</template>
<script>
export default {
    name: "EmptyComponent"
}
</script>